import { Component, Vue } from 'vue-property-decorator'
import Loader from '@/components/Loader/index.vue'
import vSelect from 'vue-select'

import api from '@/helpers/fetch'
import Fuse from 'fuse.js'

@Component({
	components: {
		Loader,
		vSelect,
	},
})
export default class AddGroupModal extends Vue {
	loadingOptions = true
	loadingEntries = false
	searchLoaded = false
	entries = [] as Array<any>

	form = {
		companyGroup: '',
	}

	options = {
		companiesGroups: [] as Array<any>,
	}

	fuseSearch(options, search) {
		const fuse = new Fuse(options, {
			keys: ['name'],
			shouldSort: true,
			ignoreLocation: true,
		})
		// @ts-ignore
		return search.length
			? fuse.search(search).map(({ item }) => item)
			: options
	}

	hidden() {
		this.$emit('hidden')
	}

	done() {
		this.$emit('done', this.entries)
		this.form.companyGroup = ''
		this.$bvModal.hide('termometro-add-group')
	}

	async loadCompaniesGroups() {
		this.loadingOptions = true
		const res = await api.get(
			'/api/thermometer/collections/distinct/companies-groups',
		)
		this.options.companiesGroups.length = 0
		this.options.companiesGroups = res.data
		this.loadingOptions = false
	}

	async loadEntries() {
		if (!this.form.companyGroup) return
		this.searchLoaded = false
		this.loadingEntries = true
		const res = await api.get(
			'/api/thermometer/collections/by/company-group?company_group=' +
				this.form.companyGroup,
		)
		this.loadingEntries = false

		if (res.ok) {
			this.entries = res.data
			this.searchLoaded = true
		}
	}

	async mounted() {
		await this.loadCompaniesGroups()
	}
}
